/**
 * @file   : AInputLabel.js
 * @author :  ()
 * @date   : 6/4/2019, 6:54:16 PM
 */
import PropTypes from 'prop-types'
import React from 'react'
import ALabelContent from './ALabelContent'

const AInputLabel = ({ htmlFor = null, children }) => {
  return (
    <label className="control-label" htmlFor={htmlFor}>
      <ALabelContent content={children} />
    </label>
  )
}

AInputLabel.propTypes = {
  htmlFor: PropTypes.string,
  children: PropTypes.node,
}

export default AInputLabel
